"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgCompletionCircle75(props) {
    return React.createElement(
        "svg",
        Object.assign({
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "currentColor",
            xmlns: "http://www.w3.org/2000/svg"
        }, props),
        React.createElement("circle", {
            cx: 12,
            cy: 12,
            r: 7.5,
            fill: "white",
            stroke: "currentColor"
        }),
        React.createElement(
            "mask",
            { id: "path-2-inside-1_503_915", fill: "white" },
            React.createElement("path", { d: "M12 6C13.1867 6 14.3467 6.35189 15.3334 7.01118C16.3201 7.67047 17.0892 8.60754 17.5433 9.7039C17.9974 10.8003 18.1162 12.0067 17.8847 13.1705C17.6532 14.3344 17.0818 15.4035 16.2426 16.2426C15.4035 17.0818 14.3344 17.6532 13.1705 17.8847C12.0067 18.1162 10.8003 17.9974 9.7039 17.5433C8.60754 17.0892 7.67047 16.3201 7.01118 15.3334C6.35189 14.3467 6 13.1867 6 12H12V6Z" })
        ),
        React.createElement("path", {
            d: "M12 6C13.1867 6 14.3467 6.35189 15.3334 7.01118C16.3201 7.67047 17.0892 8.60754 17.5433 9.7039C17.9974 10.8003 18.1162 12.0067 17.8847 13.1705C17.6532 14.3344 17.0818 15.4035 16.2426 16.2426C15.4035 17.0818 14.3344 17.6532 13.1705 17.8847C12.0067 18.1162 10.8003 17.9974 9.7039 17.5433C8.60754 17.0892 7.67047 16.3201 7.01118 15.3334C6.35189 14.3467 6 13.1867 6 12H12V6Z",
            fill: "currentColor",
            stroke: "currentColor",
            strokeWidth: 2,
            mask: "url(#path-2-inside-1_503_915)"
        })
    );
}
exports.default = SvgCompletionCircle75;